"use client";
import { videoBannerTransition } from "@/commonComponents/animations";
import { MotionBox } from "@/commonComponents/motion-components";
import SectionWrapper from "@/commonComponents/section-wrapper";
import { H6_2 } from "@/styles/theme/components/typography.fontvariant";
import { IconButton, Stack } from "@mui/material";
import dynamic from "next/dynamic";
import Image from "next/image";
import { PlayArrowRounded } from "@mui/icons-material";
import { ReactNode } from "react";

// Dynamic Imports
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

export type OurPurposeProps = {
  data: {
    title: string;
    description: string;
    videoUrl: string;
    videoPoster: string;
  };
};

const OurPurpose = (props: OurPurposeProps) => {
  const { title, description, videoUrl, videoPoster } = props.data;
  return (
    <SectionWrapper
      showSectionBgTransactionProps
      SectionProps={{
        sx: {
          background: (theme) => theme.palette.gradient.darkToLight,
        },
      }}
      color={"common.white"}
      SectionHeaderProps={{
        title: title,
        description: description,
        DescriptionTypographyProps: {
          maxWidth: 646,
          fontSize: H6_2,
        },
      }}
      navId="about-bajaj-beyond"
    >
      <Stack textAlign={"center"} width={1} maxWidth={1052} m={"auto"}>
        {videoUrl && (
          <VideoWrapper>
            <ReactPlayer
              url={videoUrl}
              width={"100%"}
              height={"100%"}
              light={
                videoPoster && (
                  <Image
                    src={videoPoster}
                    alt={title || "video"}
                    width={1050}
                    height={510}
                    style={{
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                )
              }
              controls
              playing
              playIcon={
                <IconButton
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    width: { xs: 64, md: 80 },
                    height: { xs: 64, md: 80 },
                    borderRadius: "50%",
                    bgcolor: (theme) => theme.palette.primary.main,
                    "&:hover": {
                      bgcolor: (theme) => theme.palette.primary.main,
                    },
                  }}
                >
                  <PlayArrowRounded color={"secondary"} fontSize={"large"} />
                </IconButton>
              }
            />
          </VideoWrapper>
        )}
      </Stack>
    </SectionWrapper>
  );
};

export default OurPurpose;

const VideoWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <MotionBox
      position={"relative"}
      width={1}
      sx={{
        aspectRatio: "16/9",
      }}
      mt={{ xs: 4, md: 6 }}
      mb={{ xs: 3, md: 4 }}
      zIndex={1}
      {...videoBannerTransition}
    >
      {children}
    </MotionBox>
  );
};
